/**
 * fileDownloader.component.tsx
 * Secured Communication
 *
 * Created by: Dylan Knight
 * Copyright (c) 2023 Secured Communications. All rights reserved.
 *
**/
import * as React from "react";

interface DownloaderProps {
  src: string,
  didTrigger(): void
}
export function FileDownloader(props: DownloaderProps): React.ReactElement<any, any> {
  const aRef = React.useRef<HTMLAnchorElement>(null);

  React.useEffect(() => {
    if (!props.src) { return; }
    if (aRef && aRef.current) {
      aRef.current.click();
    }
    setTimeout(() => { props.didTrigger(); }, 20);
  }, [props.src]);

  return <a ref={aRef} download href={props.src} target="_blank"></a>;
}
